import { render, staticRenderFns } from "./FIBComments.vue?vue&type=template&id=50e33930&"
import script from "./FIBComments.vue?vue&type=script&lang=js&"
export * from "./FIBComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports